export default __webpack_public_path__ + "static/img-ef-4-7cb5a786900680a57beb291b3a1831e5.png";